import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-cookie-policy',
  imports: [],
  templateUrl: './cookie-policy.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cookie-policy.scss',
})
export class CookiePolicy {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Cookie Policy';
  protected readonly seoDescription =
    'Find out how Mari Group uses cookies and similar technologies to enhance your experience and analyze site performance.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Cookie Policy', path: '/cookie-policy' },
      ],
    });
  }
}
